"use client"
import { Analytics } from "@vercel/analytics/next"
import { useEffect, useState } from "react"

/**
 * Vercel Web Analytics used to render unconditionally in layout.tsx, outside the
 * cookie-consent gate — so clicking "Decline" still sent page views to a
 * third-party processor, and the banner's "No third-party tracking" claim was
 * false even with every other analytics ID unset.
 *
 * Mirrors the consent listener in components/Analytics.tsx so both respond to
 * the same ze:consent event.
 */
export default function VercelAnalyticsGated() {
  const [consented, setConsented] = useState(false)

  useEffect(() => {
    function check() {
      try { setConsented(localStorage.getItem("ze_cookie_consent") === "true") } catch { /* private mode */ }
    }
    check()
    window.addEventListener("ze:consent", check)
    return () => window.removeEventListener("ze:consent", check)
  }, [])

  if (!consented) return null
  return <Analytics />
}
